<template>
   <div class="card-body" style="background-color: #f0f2f5">
     <div class="col-12 col-md-10 col-lg-11 col-xl-9 m-auto">
        <div class="container-fluid">

          <div class="col-12 px-2 mt-2 mb-4">
            <div class="card p-2" style="min-height: 200px">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th>SL</th>
                    <th class="text-center">Job Title</th>
                    <th class="text-center">Company Name</th>
                    <th class="text-center">Expected Salary</th>
                    <th class="text-center">Current Salary</th>
                    <th class="text-center">Application Date</th>
                    <th class="text-center">CV</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, i) in jobList.data" :key="i">
                    <td>{{ i + 1 + ((jobList.current_page - 1) * parseInt(jobList.per_page)) }}</td>
                    <td class="text-center">{{ item.title }}</td>
                    <td class="text-center">{{ item.company_name }}</td>
                    <td class="text-right">{{ item.expected_salary }}</td>
                    <td class="text-right">{{ item.current_salary }}</td>
                    <td class="text-center">{{ item.application_date }}</td>
                    <td class="text-center">
                      <button v-if="item.attachments.length > 0" class="btn btn-primary btn-sm"
                              style="cursor: pointer"
                              @click="viewAttachments(item.attachments)"
                      >
                        <i class="fas fa-eye"></i>
                        View
                      </button>
                      <span v-else class="badge btn-danger">
                            No CV
                          </span>
                    </td>
                    <td class="text-center text-capitalize">{{ item.application_status_name }}</td>
                    <td class="text-center">
                      <button class="btn btn-primary btn-sm"
                              @click="navigateToDetailPage(item)"
                              style="cursor: pointer"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <p v-if="jobList.data && jobList.data.length < 0" class="text-center mt-5">No data</p>
              </div>
            </div>
          </div>

          <div class="px-2  bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
          </div>
        </div>
     </div>

     <ViewAttachment
         ref="viewAttachmentRef"
         :attachments="modalAttachments"
     />
   </div>
</template>

<script setup>
import Pagination from '@/components/atom/Pagination'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {computed, inject, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import ViewAttachment from '@/views/page/company/ngo/voucher/payment/ViewAttachmentModal.vue'

const loading = ref(false)
const jobList = ref([])
const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const modalAttachments = ref([]);
const viewAttachmentRef = ref();
const {
  fetchUserJobApplicationList
} = handleHrPayroll()
const params = ref({
  offset: 20,
});
const user = computed(() => store.state.user.user)

const getQuery = () => {
  let query = '?offset=' + params.value.offset;
  if (route.query.page) query += '&page=' + route.query.page;
  return query;
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getJobList();
}

const getJobList = async () => {
  const query = getQuery();
  loading.value = true
  jobList.value = []

  await fetchUserJobApplicationList(user.value.id, query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    jobList.value = res.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

function navigateToDetailPage(item) {
  let param = {
    jobPostSlug: item.slug,
  }
  let query = route.query;

  router.push({
    name:  'job-post-details',
    params: param,
    query: query
  })
}

const viewAttachments = (attachments) => {
  modalAttachments.value = [];
  modalAttachments.value = attachments;
  viewAttachmentRef.value && viewAttachmentRef.value.toggleModal();
}

onMounted(() => {
  Promise.all([
    getJobList(),
  ])
})
</script>

<style scoped>


</style>
